export default {
	TITLE: 'Operational Responsibilities',
	TABLE_FILTER_ACTIVE: 'Active',
	WORKPLACE_OPERATIONAL_RESPONSIBILITY_ADDED:
		'Workplace operational responsibility added!',
	WAITING_TIME_SCHEDULES_TABLE_TITLE: 'Waiting time schedules',
	EMPLOYMENTS_TABLE_TITLE: 'Employees',
	JUICER_DETAILS_TOOLTIP: 'View juicer details',
};
